import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createCommentVNode as _createCommentVNode, vShow as _vShow, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4beded04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "topic-season-wrapper" }
const _hoisted_2 = { class: "layout-inner -full-width" }
const _hoisted_3 = {
  class: "global-search-container",
  onsubmit: "return false;",
  action: "/"
}
const _hoisted_4 = { class: "global-search-input" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-search icon" }, null, -1))
const _hoisted_6 = { class: "layout-inner -top-and-bottom" }
const _hoisted_7 = { class: "topic-season-content" }
const _hoisted_8 = { class: "global-list-numbers" }
const _hoisted_9 = { class: "current" }
const _hoisted_10 = { class: "all" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, "表示中", -1))
const _hoisted_12 = {
  key: 0,
  class: "season-list"
}
const _hoisted_13 = { class: "category" }
const _hoisted_14 = { class: "name" }
const _hoisted_15 = {
  key: 0,
  class: "global-empty-text"
}
const _hoisted_16 = {
  key: 1,
  class: "global-empty-text"
}
const _hoisted_17 = { ref: "seasonsObserverTarget" }
const _hoisted_18 = { class: "global-loading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseBreadcrumb = _resolveComponent("BaseBreadcrumb")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseDialog = _resolveComponent("BaseDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_BaseBreadcrumb, { breadcrumbs: _ctx.breadcrumbs }, null, 8, ["breadcrumbs"]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              type: "search",
              class: "input",
              placeholder: "検索ワードを入力",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.keyword) = $event))
            }, null, 512), [
              [_vModelText, _ctx.searchForm.keyword]
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.seasons.list.length), 1),
            _createElementVNode("span", _hoisted_10, "/ " + _toDisplayString(_ctx.seasons.totalNumber) + "件", 1),
            _hoisted_11
          ]),
          (_ctx.seasons.list.length > 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.seasons.list, (season, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: season.id,
                    class: "item"
                  }, [
                    _createVNode(_component_router_link, {
                      to: {
                name: 'seasonDetailHome',
                params: { topic_id: season.topic_id, season_id: season.id } },
                      class: "season-list-card"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("p", _hoisted_13, [
                          _createElementVNode("span", {
                            class: "categoryIcon",
                            style: _normalizeStyle({ 'background-color': season.category_color })
                          }, null, 4)
                        ]),
                        _createElementVNode("p", _hoisted_14, _toDisplayString(season.topic_name) + " " + _toDisplayString(season.name), 1),
                        _createElementVNode("div", {
                          ref: el => { if (el) _ctx.seasonSubmenuElements[index] = el },
                          class: "global-dropdown"
                        }, null, 512)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]))
                }), 128))
              ]))
            : (!_ctx.seasons.isLoading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.isSearching)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, "該当するシーズンがありません"))
                    : (_openBlock(), _createElementBlock("p", _hoisted_16, "登録されているシーズンがありません"))
                ], 64))
              : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_17, null, 512),
          _withDirectives(_createElementVNode("div", _hoisted_18, null, 512), [
            [_vShow, _ctx.seasons.isLoading]
          ])
        ])
      ])
    ]),
    (_ctx.seasonDialogArchive.isOpen)
      ? (_openBlock(), _createBlock(_component_BaseDialog, {
          key: 0,
          dialog: _ctx.seasonDialogArchive,
          onCloseDialog: _ctx.closeSeasonDialogArchive,
          onOnConfirm: _ctx.archiveSeason
        }, null, 8, ["dialog", "onCloseDialog", "onOnConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.seasonDialogDelete.isOpen)
      ? (_openBlock(), _createBlock(_component_BaseDialog, {
          key: 1,
          dialog: _ctx.seasonDialogDelete,
          onCloseDialog: _ctx.closeSeasonDialogDelete,
          onOnConfirm: _ctx.deleteSeason
        }, null, 8, ["dialog", "onCloseDialog", "onOnConfirm"]))
      : _createCommentVNode("", true)
  ], 64))
}